import { render, staticRenderFns } from "./ChallengeRegistration.vue?vue&type=template&id=115b6084"
import script from "./ChallengeRegistration.vue?vue&type=script&lang=js"
export * from "./ChallengeRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports